{
  "title": "Legend Lore",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level divination",
  "level": 5,
  "castingTime": "10 minutes",
  "range": "Self",
  "components": "V, S, M (incense worth at least 250 gp, which the spell consumes, and four ivory strips worth at least 50 gp each)",
  "duration": "Instantaneous",
  "description": [
    "Name or describe a person, place, or object. The spell brings to your mind a brief summary of the significant lore about the thing you named. The lore might consist of current tales, forgotten stories, or even secret lore that has never been widely known. If the thing you named isn’t of legendary importance, you gain no information. The more information you already have about the thing, the more precise and detailed the information you receive is.",
    "The information you learn is accurate but might be couched in figurative language. For example, if you have a mysterious magic axe on hand, the spell might yield this information: Woe to the evildoer whose hand touches the axe, for even the haft slices the hand of the evil ones. Only a true Child of Stone, lover and beloved of Moradin, may awaken the true powers of the axe, and only with the sacred word Rudnogg on the lips."
  ],
  "spellLists": ["bard", "cleric", "wizard"]
}
